module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-product-guide"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-inner"
  }, [_vm._m(1), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        SELECT YOUR BRICK FROM A\n                        RANGE OF COLORS.\n                    ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "learn-more-button",
    attrs: {
      "to": "/pricing-guide",
      "tag": "button"
    }
  }, [_c('span', [_vm._v("VIEW BRICK PRICING HERE")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('div', {
    staticClass: "product-guide-map"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "599",
      "src": "images/Product-Guide/engravedbricks01.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "claret-full-range-brick",
    attrs: {
      "tag": "a",
      "to": "/virtual/claret-full-range-brick"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "landmark-gray-brick",
    attrs: {
      "tag": "a",
      "to": "/virtual/landmark-gray-brick"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "regimental-red-brick",
    attrs: {
      "tag": "a",
      "to": "/virtual/regimental-red-brick"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "medium-ironspot-brick",
    attrs: {
      "tag": "a",
      "to": "/virtual/medium-ironspot-brick"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "mesabi-granite-brick",
    attrs: {
      "tag": "a",
      "to": "/virtual/mesabi-granite-brick"
    }
  })], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('div', {
    staticClass: "product-guide-map"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "401",
      "src": "images/Product-Guide/engravedbricks02.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "red-blend-tile",
    attrs: {
      "tag": "a",
      "to": "/virtual/red-blend-tile"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "medium-ironspot-tile",
    attrs: {
      "tag": "a",
      "to": "/virtual/medium-ironspot-tile"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "manganese-tile",
    attrs: {
      "tag": "a",
      "to": "/virtual/manganese-tile"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "absolute-black-granite-tile",
    attrs: {
      "tag": "a",
      "to": "/virtual/absolute-black-granite-tile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        SELECT YOUR TILE FROM A\n                        RANGE OF COLORS.\n                    ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "learn-more-button",
    attrs: {
      "to": "/pricing-guide",
      "tag": "button"
    }
  }, [_c('span', [_vm._v("VIEW TILE PRICING HERE")])])], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        OFFER A KEEPSAKE BRICK\n                        OR TILE TO YOUR DONORS.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Keepsake Replicas are an additional fundraising\n                        item that offer donors a display piece for their\n                        home or office.\n                    ")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "learn-more-button",
    attrs: {
      "to": "/pricing-guide",
      "tag": "button"
    }
  }, [_c('span', [_vm._v("VIEW REPLICA & PLAQUE PRICING HERE")])])], 1)]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        ADD UNIQUE PERSONALIZATION\n                        OPTIONS, SUCH AS SYMBOLS\n                        AND LOGOS TO FURTHER\n                        CUSTOMIZE YOUR PROJECT.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Select from the following options;\n                    ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "learn-more-button",
    attrs: {
      "to": "/pricing-guide",
      "tag": "button"
    }
  }, [_c('span', [_vm._v("VIEW SYMBOL & LOGO PRICING HERE")])])], 1)]), _vm._v(" "), _vm._m(10)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbo-wrapper product-guide"
  }, [_c('div', {
    staticClass: "jumbo-main"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('p', {
    staticClass: "t15"
  }, [_vm._v("PRODUCT GUIDE")]), _vm._v(" "), _c('h2', {
    staticClass: "t42"
  }, [_vm._v("\n                    BRICKS, TILES &\n                    "), _c('br'), _vm._v("\n                    ENGRAVING OPTIONS\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "t20"
  }, [_vm._v("Our colors and sizes are well-suited for any location.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row checkbox-list"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("\n                        NO"), _c('br'), _vm._v("\n                        UPFRONT COSTS\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("\n                        NO"), _c('br'), _vm._v("\n                        MINIMUM ORDER\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("\n                        FREE"), _c('br'), _vm._v("\n                        SHIPPING\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("\n                        FREE PERSONALIZED\n                        "), _c('br'), _vm._v("\n                        MARKETING SAMPLE!\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                        Bricks are best-suited for in-ground\n                        applications such as walkways, plazas, parks,\n                        patios, and more.\n                        Once you select your color, request your\n                        "), _c('strong', [_vm._v("Free Personalized Marketing Sample!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "body-area-list"
  }, [_c('li', [_c('span', [_vm._v("Two Standard Sizes - 4” x 8” and 8” x 8”")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Mesabi Granite in 12” x 12” Only")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Rated for Pedestrian & Light Vehicular Traffic")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                        Tiles are best suited for vertical installations,\n                        such as walls, partitions, seat walls, columns,\n                        indoor and outdoor use.\n                        Once you select your color, request your\n                        "), _c('strong', [_vm._v("Free Personalized Marketing Sample!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "body-area-list"
  }, [_c('li', [_c('span', [_vm._v("Two Standard Sizes - 4” x 8” & 8” x 8”")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Absolute Black Granite in 12” x 12” Only")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "body-area-list"
  }, [_c('li', [_c('span', [_vm._v("Replicas are a duplicate of the installed brick")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Hand-crafted using the same size, material and message")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Add a plaque to your replica to commemorate your project")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "401",
      "src": "images/Product-Guide/engravedbricks03.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "439",
      "src": "images/Product-Guide/engravedbricks04.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        SELECT THE FONT STYLE THAT’S\n                        RIGHT FOR YOUR PROJECT.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        All inscriptions, regardless of font, are engraved\n                        in all uppercase, and centered vertically and\n                        horizontally.\n                    ")]), _vm._v(" "), _c('ul', {
    staticClass: "body-area-list"
  }, [_c('li', [_c('span', [_vm._v("Frutiger - 16 Characters per line")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Univers - 20 Characters per line")])])]), _vm._v(" "), _c('div', {
    staticClass: "frl-recommended"
  }, [_c('img', {
    attrs: {
      "width": "55",
      "height": "58",
      "src": "images/recommendedicon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Frutiger is recommended for its quality engraving and is our most popular font.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "body-area-list"
  }, [_c('li', [_c('span', [_vm._v("Small & Large Symbols")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Greek Characters")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Project Logos")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Donor Logos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "373",
      "src": "images/Product-Guide/engravedbricks05.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48cf3e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/ProductGuide.vue
// module id = PK/H
// module chunks = 1